/*
 * @Author: your name
 * @Date: 2019-12-21 15:13:56
 * @LastEditTime: 2020-04-02 21:48:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \周记 张经伟e:\gi劳务\src\router\modules\performanceDisplay.js
 */
const PerformanceDisplay = () => import('@/views/performanceDisplay/index')
const SchoolHospital = () => import('@/views/performanceDisplay/schoolHospital/SchoolHospital')//学校医院
const SchoolHospitalDetail = () => import('@/views/performanceDisplay/schoolHospital/SchoolHospitalDetail')//学校医院详情
const CommercialHousing = () => import('@/views/performanceDisplay/commercialHousing/CommercialHousing')//商贸住宅
const CommercialHousingDetail = () => import('@/views/performanceDisplay/commercialHousing/CommercialHousingDetail')//商贸住宅
const Exhibition = () => import('@/views/performanceDisplay/exhibition/Exhibition')//展览展示
const ExhibitionDetail = () => import('@/views/performanceDisplay/exhibition/ExhibitionDetail')//展览展示详情
const CurtainWallElectromechanical = ()=> import('@/views/performanceDisplay/curtainWallElectromechanical/CurtainWallElectromechanical')//幕墙机电
const CurtainWallElectromechanicalDetail = ()=> import('@/views/performanceDisplay/curtainWallElectromechanical/CurtainWallElectromechanicalDetail')//幕墙机电详情
const HotelOffice = ()=> import('@/views/performanceDisplay/hotelOffice/HotelOffice')//酒店办公
const HotelOfficeDetail = ()=> import('@/views/performanceDisplay/hotelOffice/HotelOfficeDetail')//酒店办公详情


const performanceDisplayRouter = [
    {
        path: '/performanceDisplay',
        name: 'performanceDisplay',
        component: PerformanceDisplay,
        redirect: {name: 'schoolHospital'},
        children: [
            {
                path: 'schoolHospital',
                name: 'schoolHospital',
                component: SchoolHospital,
                meta: {
                    name: '学校/医院',
                    keepAlive: true,
                }
            },
            {
                path: 'schoolHospital/detail/:id',
                name: 'schoolHospitalDetail',
                component: SchoolHospitalDetail,
                meta: {
                    name: '学校/医院',
                    // keepAlive: true,
                }
            },
            {
                path: 'commercialHousing',
                name: 'commercialHousing',
                component: CommercialHousing,
                meta: {
                    name: '商贸/住宅',
                    keepAlive: true,
                }
            },
            {
                path: 'commercialHousing/detail/:id',
                name: 'commercialHousingDetail',
                component: CommercialHousingDetail,
                meta: {
                    name: '商贸/住宅',
                    // keepAlive: true,
                }
            },
            {
                path: 'exhibition',
                name: 'exhibition',
                component: Exhibition,
                meta: {
                    name: '展览/展示',
                    keepAlive: true,
                }
            },
            {
                path: 'exhibition/detail/:id',
                name: 'exhibitionDetail',
                component: ExhibitionDetail,
                meta: {
                    name: '展览/展示',
                    // keepAlive: true,
                }
            },
            {
                path: 'curtainWallElectromechanical',
                name: 'curtainWallElectromechanical',
                component: CurtainWallElectromechanical,
                meta: {
                    name: '幕墙/机电',
                    keepAlive: true,
                }
            },
            {
                path: 'curtainWallElectromechanical/detail/:id',
                name: 'curtainWallElectromechanicalDetail',
                component: CurtainWallElectromechanicalDetail,
                meta: {
                    name: '幕墙/机电',
                    // keepAlive: true,
                }
            },
            {
                path: 'hotelOffice',
                name: 'hotelOffice',
                component: HotelOffice,
                meta: {
                    name: '酒店/办公',
                    keepAlive: true,
                }
            },
            {
                path: 'hotelOffice/detail/:id',
                name: 'hotelOfficeDetail',
                component: HotelOfficeDetail,
                meta: {
                    name: '酒店/办公',
                    // keepAlive: true,
                }
            },
        ]
    }
]
export default performanceDisplayRouter;


// WEBPACK FOOTER //
// ./src/router/modules/performanceDisplay.js